import { Component, OnInit } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';
import { Meta, Title, MetaDefinition } from '@angular/platform-browser';
import { version } from '../../../environments/version';
import { ReportesService, SharedService } from 'src/app/services/service.index';
@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styles: []
})
export class BreadcrumbsComponent implements OnInit {
  version: string = '';
  label: string = '';
  isfinantah: boolean;
  miFiel = '';
  constructor(
    private router: Router,
    public title: Title,
    public meta: Meta,
    public shared: SharedService,
    private reportesService: ReportesService
   ) {
    this.shared.getGitVersion().subscribe(apiResponse => {
    //const dateMatch = apiResponse.match(/date: '(\d{4}-\d{2}-\d{2})'/);
    const hashMatch = apiResponse.match(/hash: '([a-f0-9]+)'/);
    //const longHashMatch = apiResponse.match(/longHash: '([a-f0-9]+)'/);


    //const apiDate = dateMatch ? dateMatch[1] : null;
    const apiHash = hashMatch ? hashMatch[1] : null;
    //const apiLongHash = longHashMatch ? longHashMatch[1] : null;
    this.version = version.date.replace(/-/g, '') +': '+ version.hash + ': '+apiHash;
    }, err => {
      this.version = version.date.replace(/-/g, '') +': '+ version.hash;
    })
    this.isfinantah = false;
    if (localStorage.getItem('quiensoy')) {
      if (localStorage.getItem('quiensoy') === 'finantah') {
        this.isfinantah = true;
      }
    }
    this.getDataRoute()
      .subscribe( data => {

      //  console.log( data );

        this.label = data.titulo;
        this.title.setTitle( this.label );

        let metaTag: MetaDefinition = {
          name: 'description',
          content: this.label
        };

        this.meta.updateTag(metaTag);

      });

      this.reportesService.getMiFielBalance().subscribe(resp => {
        this.miFiel = resp.balance.document.available
      })
  }

  getDataRoute() {

    return this.router.events
        .filter( evento => evento instanceof ActivationEnd  )
        .filter( (evento: ActivationEnd) => evento.snapshot.firstChild === null )
        .map( (evento: ActivationEnd) => evento.snapshot.data );

  }


  ngOnInit() {
  }

}
